import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { milestone_submit, update_mile_status, completeProject } from '../../Apis';


export const CreateMIlestone = createAsyncThunk('CreateMIlestone', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await milestone_submit(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const UpdateMileStoneStatus = createAsyncThunk('UpdateMileStoneStatus', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_mile_status(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});





const milestoneSlice = createSlice({
    name: 'mile',
    initialState: {
        error: null,
        success: false,

    },
    reducers: {
        clearMileStatus: state => {
            state.success = false;
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder

            .addCase(CreateMIlestone.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(CreateMIlestone.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(CreateMIlestone.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(UpdateMileStoneStatus.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(UpdateMileStoneStatus.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(UpdateMileStoneStatus.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearMileStatus } = milestoneSlice.actions;
export default milestoneSlice.reducer;

